import { __decorate, __metadata } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
export var E_AlertType;
(function (E_AlertType) {
    E_AlertType["error"] = "error";
    E_AlertType["warning"] = "warning";
    E_AlertType["success"] = "success";
    E_AlertType["info"] = "info";
})(E_AlertType || (E_AlertType = {}));
let AlertImpl = class AlertImpl extends Vue {
    get Klass() {
        return ['login-alert', this.type ? `login-alert--${this.type}` : null];
    }
};
__decorate([
    Prop({
        type: String,
    }),
    __metadata("design:type", String)
], AlertImpl.prototype, "title", void 0);
__decorate([
    Prop({
        type: String,
    }),
    __metadata("design:type", String)
], AlertImpl.prototype, "content", void 0);
__decorate([
    Prop({
        type: String,
    }),
    __metadata("design:type", String)
], AlertImpl.prototype, "type", void 0);
AlertImpl = __decorate([
    Component({
        name: 'Alert',
    })
], AlertImpl);
export { AlertImpl };
